import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";

import { updateTabPath } from '../../../store/actions';

export default function LeftMenuCollect({expanded,getLeftMenuExpandActionFromChild}) {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const themeMode = useSelector(state => state.themeMode);
    // const currentSurvey = useSelector(state => state.currentSurvey);
    const topMenuTabs = useSelector(state => state.topMenuTabs);

    // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
    const currentSurvey = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.currentSurvey;

    const [collectMenuItems, setCollectMenuItems] = useState([
        {
            id: 1,
            name: "Overview",
            icon: (
                <svg
                    strokeWidth="1.5"
                    stroke={themeMode === "dark" ? "currentColor" : "black"}
                    className="size-3.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                    <path
                        d="M10.5 16.75C8.71 16.75 7.25 15.29 7.25 13.5C7.25 10.05 10.05 7.25 13.5 7.25C15.29 7.25 16.75 8.71 16.75 10.5C16.75 13.95 13.95 16.75 10.5 16.75ZM13.5 8.75C10.88 8.75 8.75 10.88 8.75 13.5C8.75 14.46 9.54 15.25 10.5 15.25C13.12 15.25 15.25 13.12 15.25 10.5C15.25 9.54 14.46 8.75 13.5 8.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                </svg>
            ),
        },
        {
            id: 2,
            name: "Recipients",
            icon: (
                <svg
                    strokeWidth="1.5"
                    stroke={themeMode === "dark" ? "currentColor" : "black"}
                    className="size-3.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M18.0001 7.16C17.9401 7.15 17.8701 7.15 17.8101 7.16C16.4301 7.11 15.3301 5.98 15.3301 4.58C15.3301 3.15 16.4801 2 17.9101 2C19.3401 2 20.4901 3.16 20.4901 4.58C20.4801 5.98 19.3801 7.11 18.0001 7.16Z"
                        stroke={themeMode === "dark" ? "currentColor" : "black"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M16.9699 14.44C18.3399 14.67 19.8499 14.43 20.9099 13.72C22.3199 12.78 22.3199 11.24 20.9099 10.3C19.8399 9.59004 18.3099 9.35003 16.9399 9.59003"
                        stroke={themeMode === "dark" ? "currentColor" : "black"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M5.96998 7.16C6.02998 7.15 6.09998 7.15 6.15998 7.16C7.53998 7.11 8.63998 5.98 8.63998 4.58C8.63998 3.15 7.48998 2 6.05998 2C4.62998 2 3.47998 3.16 3.47998 4.58C3.48998 5.98 4.58998 7.11 5.96998 7.16Z"
                        stroke={themeMode === "dark" ? "currentColor" : "black"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M6.99994 14.44C5.62994 14.67 4.11994 14.43 3.05994 13.72C1.64994 12.78 1.64994 11.24 3.05994 10.3C4.12994 9.59004 5.65994 9.35003 7.02994 9.59003"
                        stroke={themeMode === "dark" ? "currentColor" : "black"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12.0001 14.63C11.9401 14.62 11.8701 14.62 11.8101 14.63C10.4301 14.58 9.33008 13.45 9.33008 12.05C9.33008 10.62 10.4801 9.46997 11.9101 9.46997C13.3401 9.46997 14.4901 10.63 14.4901 12.05C14.4801 13.45 13.3801 14.59 12.0001 14.63Z"
                        stroke={themeMode === "dark" ? "currentColor" : "black"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M9.09021 17.78C7.68021 18.72 7.68021 20.26 9.09021 21.2C10.6902 22.27 13.3102 22.27 14.9102 21.2C16.3202 20.26 16.3202 18.72 14.9102 17.78C13.3202 16.72 10.6902 16.72 9.09021 17.78Z"
                        stroke={themeMode === "dark" ? "currentColor" : "black"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            ),
            open: true,
            children: [
                {
                    id: 5,
                    name: "Recipient List",
                },
                {
                    id: 6,
                    name: "Import Recipient List",
                },
                {
                    id: 7,
                    name: "Import From Survey",
                },
            ],
        },
        {
            id: 3,
            name: "Email Template",
            icon: (
                <svg
                    strokeWidth="1.5"
                    stroke={themeMode === "dark" ? "currentColor" : "black"}
                    className="size-3.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7 12C3 12 3 13.79 3 16V17C3 19.76 3 22 8 22H16C20 22 21 19.76 21 17V16C21 13.79 21 12 17 12C16 12 15.72 12.21 15.2 12.6L14.18 13.68C13 14.94 11 14.94 9.81 13.68L8.8 12.6C8.28 12.21 8 12 7 12Z"
                        stroke={themeMode === "dark" ? "currentColor" : "black"}
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M19 12V6C19 3.79 19 2 15 2H9C5 2 5 3.79 5 6V12"
                        stroke={themeMode === "dark" ? "currentColor" : "black"}
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M10.5498 9.22998H13.8798"
                        stroke={themeMode === "dark" ? "currentColor" : "black"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M9.72021 6.22998H14.7202"
                        stroke={themeMode === "dark" ? "currentColor" : "black"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            ),
        },
        {
            id: 4,
            name: "Schedule",
            icon: (
                <svg
                    strokeWidth="1.5"
                    stroke={themeMode === "dark" ? "currentColor" : "black"}
                    className="size-3.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                    <path
                        d="M15.7101 15.93C15.5801 15.93 15.4501 15.9 15.3301 15.82L12.2301 13.97C11.4601 13.51 10.8901 12.5 10.8901 11.61V7.51001C10.8901 7.10001 11.2301 6.76001 11.6401 6.76001C12.0501 6.76001 12.3901 7.10001 12.3901 7.51001V11.61C12.3901 11.97 12.6901 12.5 13.0001 12.68L16.1001 14.53C16.4601 14.74 16.5701 15.2 16.3601 15.56C16.2101 15.8 15.9601 15.93 15.7101 15.93Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                </svg>
            ),
        },
    ]);

    useEffect(() => {
        if (collectMenuItems.length > 0) {
            if (location.pathname.includes("collect-import-recipient-list")) {
                setSelectedCollectMenuItem(collectMenuItems[1].children[1]);
            } else if (location.pathname.includes("collect-recipient-list")) {
                setSelectedCollectMenuItem(collectMenuItems[1].children[0]);
            } else if (location.pathname.includes("collect-import-from-survey")) {
                setSelectedCollectMenuItem(collectMenuItems[1].children[2]);
            } else if (location.pathname.includes("collect-overview")) {
                setSelectedCollectMenuItem(collectMenuItems[0]);
            } else if (location.pathname.includes("collect-email-template")) {
                setSelectedCollectMenuItem(collectMenuItems[2]);
            } else if (location.pathname.includes("collect-schedule")) {
                setSelectedCollectMenuItem(collectMenuItems[3]);
            }
        }
    }, [collectMenuItems]);

    const [selectedCollectMenuItem, setSelectedCollectMenuItem] = useState(collectMenuItems[0]);

    const selectCollectMenuItem = (item) => {
        if(window.innerWidth<1024 && expanded){
            getLeftMenuExpandActionFromChild(false)
          }
        console.log("item : ", item);
        console.log("currentSurvey : ", currentSurvey);
        if (item.open !== undefined) {
            item.open = !item.open;
            setCollectMenuItems([...collectMenuItems]);
        } else {
            setSelectedCollectMenuItem(item);
        }
        if (item.name === "Import Recipient List") {
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Import Recipient List', `/surveys/${currentSurvey.ID}/collect-import-recipient-list`));
            navigate("/surveys/" + currentSurvey.ID + "/collect-import-recipient-list");
        } else if (item.name === "Recipient List") {
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Recipient List', `/surveys/${currentSurvey.ID}/collect-recipient-list`));
            navigate("/surveys/" + currentSurvey.ID + "/collect-recipient-list");
        } else if (item.name === "Import From Survey") {
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Import From Survey', `/surveys/${currentSurvey.ID}/collect-import-from-survey`));
            navigate("/surveys/" + currentSurvey.ID + "/collect-import-from-survey");
        } else if (item.name === "Overview") {
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Overview', `/surveys/${currentSurvey.ID}/collect-overview`));
            navigate("/surveys/" + currentSurvey.ID + "/collect-overview");
        } else if (item.name === "Email Template") {
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Email Template', `/surveys/${currentSurvey.ID}/collect-email-template`));
            navigate("/surveys/" + currentSurvey.ID + "/collect-email-template");
        } else if (item.name === "Schedule") {
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Schedule', `/surveys/${currentSurvey.ID}/collect-schedule`));
            navigate("/surveys/" + currentSurvey.ID + "/collect-schedule");
        }
    };

    return (
        <div>
            <div className="flex cursor-default items-center justify-between rounded-lg pt-[0.75rem] pr-[0.75rem] pb-[1.5rem] pl-[1.25rem] text-[1.25rem] font-bold space-x-2">
                <span
                    className={` whitespace-nowrap break-words text-ellipsis  min-w-0 w-full cursor-default ${themeMode === "dark" ? "text-white" : "text-[#0F121A]"
                        }`}
                >
                    Collect
                </span>
            </div>

            <ul className="px-3 space-y-0 flex flex-col">
                {collectMenuItems.map((cmItem, index) => (
                    <li
                        key={cmItem.id}
                        className=" flex flex-col min-h-[2rem] my-0 py-0 group"
                        onClick={() => selectCollectMenuItem(cmItem)}
                    >
                        <div
                            className={`flex cursor-pointer items-center justify-between min-h-[2rem] rounded-lg px-2 py-1 hover:bg-[#A5BDFF1A] ${themeMode === "dark"
                                ? "text-white  "
                                : "text-gray-500  "
                                }
                        ${selectedCollectMenuItem.id === cmItem.id
                                    ? "bg-[#A5BDFF1A]"
                                    : "hover:bg-[#A5BDFF1A]"
                                }`}
                        >
                            <div className="flex items-center justify-between w-full">
                                <div className="flex items-center">
                                    <span className={`mr-2`}>{cmItem.icon}</span>
                                    <span
                                        className={`text-sm font-normal whitespace-nowrap break-words text-ellipsis overflow-hidden min-w-0 ${themeMode === "dark"
                                            ? `${selectedCollectMenuItem.id ===
                                                cmItem.id
                                                ? "text-[#4D7FF5]"
                                                : "focus:ring-2 focus:ring-blue-500 "
                                            }`
                                            : `text-[#0F121A] ${selectedCollectMenuItem.id ===
                                                cmItem.id
                                                ? "text-[#3566E2]"
                                                : "focus:ring-2 focus:ring-blue-500 "
                                            }`
                                            }`}
                                    >
                                        {cmItem.name}
                                    </span>
                                </div>

                                {cmItem.children && (
                                    <div className="flex items-center">
                                        <span className="mr-2">
                                            <svg
                                                className="size-4"
                                                fill="currentColor"
                                                viewBox="0 0 16 16"
                                                xmlns="http://www.w3.org/2000/svg"
                                                transform={
                                                    !cmItem.open ? "rotate(270)" : ""
                                                }
                                            >
                                                <path d="M7.8,10.8L11.7,7H4L7.8,10.8z"></path>
                                            </svg>
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>

                        {cmItem.children && cmItem.open && (
                            <ul className="pl-6 space-y-0 flex flex-col">
                                {cmItem.children.map((child) => (
                                    <li
                                        key={child.id}
                                        className=" flex flex-col min-h-[2rem] my-0 py-0 group"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            selectCollectMenuItem(child);
                                        }}
                                    >
                                        <div
                                            className={`flex cursor-pointer items-center justify-between min-h-[2rem] rounded-lg px-2 py-1 hover:bg-[#A5BDFF1A] ${themeMode === "dark"
                                                ? "text-white  "
                                                : "text-gray-500  "
                                                }
                                        ${selectedCollectMenuItem.id === child.id
                                                    ? "bg-[#A5BDFF1A]"
                                                    : "hover:bg-[#A5BDFF1A]"
                                                }`}
                                        >
                                            <div className="flex items-center">
                                                <span className={`mr-2`}>
                                                    {child.icon}
                                                </span>
                                                <span
                                                    className={`text-sm font-normal whitespace-nowrap break-words text-ellipsis overflow-hidden min-w-0 ${themeMode === "dark"
                                                        ? `${selectedCollectMenuItem.id ===
                                                            child.id
                                                            ? "text-[#4D7FF5]"
                                                            : "focus:ring-2 focus:ring-blue-500 "
                                                        }`
                                                        : `text-[#0F121A] ${selectedCollectMenuItem.id ===
                                                            child.id
                                                            ? "text-[#3566E2]"
                                                            : "focus:ring-2 focus:ring-blue-500 "
                                                        }`
                                                        }`}
                                                >
                                                    {child.name}
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li>
                ))}
            </ul>

            <div
                className={`h-px mt-4 ${themeMode === "dark" ? "bg-[#ffffff17]" : "bg-[#0000001a]"
                    }`}
            ></div>
        </div>
    )
}